import { render, staticRenderFns } from "./authAdmin.vue?vue&type=template&id=1c975071"
import script from "./authAdmin.vue?vue&type=script&lang=js"
export * from "./authAdmin.vue?vue&type=script&lang=js"
import style0 from "./authAdmin.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports